import React from 'react';
import DeviationDuperbrowseContext from '../../../../Duperbrowse/DeviationDuperbrowseContext';
import { getDeviationResourceType } from '../../../../DeviationViews/_helpers';
import SidebarBlockWrapper from '../../../_partials/SidebarBlockWrapper';
import MeasuredDeviationsMosaic from '../../../../MeasuredDeviationsMosaic';
import { MeasuredCookieType } from '../../../../Measured/redux/types';
import s from './DeviationMosaic.scss';
var MOSAIC_HEIGHT = 289; // 321 - 2 * 16 because the measured mosaic has paddings removed
/** Sidebar block layout id 3 */
var DeviationMosaic = function (_a) {
    var _b, _c, _d;
    var block = _a.block, parentDeviation = _a.deviation;
    return (React.createElement(SidebarBlockWrapper, { deviation: parentDeviation, block: block },
        React.createElement("div", { className: s['root'] },
            React.createElement(DeviationDuperbrowseContext, { streamId: "sidebar-mosaic-" + block.contentType, deviations: (_b = block.deviations) !== null && _b !== void 0 ? _b : [], parent: {
                    typeId: getDeviationResourceType(parentDeviation),
                    itemId: parentDeviation.deviationId,
                } },
                React.createElement(MeasuredDeviationsMosaic, { deviations: (_d = (_c = block === null || block === void 0 ? void 0 : block.deviations) === null || _c === void 0 ? void 0 : _c.slice(0, 3)) !== null && _d !== void 0 ? _d : [], height: MOSAIC_HEIGHT, cookieType: MeasuredCookieType.DEVIATION_MOBILE_SIDEBAR })))));
};
DeviationMosaic.displayName = 'DeviationMosaic';
export default DeviationMosaic;
//# sourceMappingURL=DeviationMosaic.js.map